var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",class:{ skelly: !_vm.init, full: _vm.score >= _vm.max },style:(_vm.styles)},_vm._l((_vm.markers),function(marker,index){return _c('span',{key:index,staticClass:"marker",style:({ left: `${marker.val}%`, '--score': `'${Math.round(marker.val * _vm.max / 100)}'` })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }